import { useAuth } from '@/hooks/use-auth/use-auth';
import PublicLayout from '@/layouts/public-layout/public.layout';
import { Navigate } from 'react-router-dom';

type OnboardingRouteProps = {
  children: React.ReactNode;
};

export const OnboardingRoute = ({ children }: OnboardingRouteProps) => {
  const { isAuthorized } = useAuth();

  if (!isAuthorized) {
    return <Navigate to="/sign-up" replace />;
  }

  return <PublicLayout>{children}</PublicLayout>;
};
